module.exports = __webpack_public_path__ + "static/media/share-registrar.2b6d63ea.svg";